import "../css/index.scss";

document.addEventListener("DOMContentLoaded", function () {
    const mobileNavButton = document.getElementById("mobileNavToggle");
    const mobileNavBar = document.getElementById("mobileNav");

    const mobileNavBarIcon = document.getElementById("mobileNavBarIcon");
    const mobileNavCloseIcon = document.getElementById("mobileNavCloseIcon");

    const mainPageContent = document.querySelector(".gh-main");

    if (mobileNavButton && mobileNavBar && mobileNavBarIcon && mobileNavCloseIcon && mainPageContent) {
        mobileNavButton.addEventListener("click", function () {
            mobileNavBarIcon.classList.toggle("hidden");
            mobileNavBarIcon.classList.toggle("invisible");

            mobileNavCloseIcon.classList.toggle("hidden");
            mobileNavCloseIcon.classList.toggle("invisible");

            mobileNavBar.classList.toggle("invisible");
            mobileNavBar.classList.toggle("h-0");
            mobileNavBar.classList.toggle("h-auto");
            mobileNavBar.classList.toggle("opacity-0");
            mobileNavBar.classList.toggle("opacity-100");

            mainPageContent.classList.toggle("blur-[2px]");
        });

        mainPageContent.addEventListener("click", function () {
            if (mobileNavBar.classList.contains("opacity-100")) {
                mobileNavButton.click();
            }
        });
    }
});
